import { render, staticRenderFns } from "./PageBody.vue?vue&type=template&id=95aad56a&scoped=true&"
import script from "./PageBody.vue?vue&type=script&lang=ts&"
export * from "./PageBody.vue?vue&type=script&lang=ts&"
import style0 from "./PageBody.vue?vue&type=style&index=0&id=95aad56a&lang=scss&scoped=true&"
import style1 from "./PageBody.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95aad56a",
  null
  
)

export default component.exports